/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';

export function optionSelectMessageFormatter(msg, passType) {
    if (!passType) {
        return null;
    }

    if (msg.includes('Missing feature')) {
        const selections = passType.features['option-select'];

        let errMsg = '';
        let first = true;
        for (const selection of selections) {
            if (!first) {
                errMsg = `${errMsg}, `;
            }
            errMsg = `${errMsg}${selection.label}`;
            first = false;
        }

        if (msg.includes('start-date')) {
            errMsg = 'Start date';
        }

        return `${errMsg}: Must not be empty.`;
    }

    return null;
}

export function flexTextAttributeMessageFormatter(msg, passType) {
    if (!passType) {
        return null;
    }

    const label = get(passType, ['features', 'flex-text-attr', 'label']);
    return `${label}: Must not be empty.`;
}

export function optionSelectInputId(displayNumber, field, passType) {
    if (!passType) {
        return `option-select-${displayNumber}`;
    }

    const selections = passType.features['option-select'];
    if (selections.length < 1) {
        return `${displayNumber}`;
    }
    return `option-select-${selections[0].type}-${displayNumber}`;
}
